import PropTypes from 'prop-types';

const defaultProps = {};

const propTypes = {
  excerpt: PropTypes.string.isRequired,
};

export default function CertificationExcerpt({
  excerpt,
}) {
  return (
    <div
      className="text-gray-500 text-sm leading-6"
      dangerouslySetInnerHTML={{ __html: excerpt }}
    />
  );
}

CertificationExcerpt.defaultProps = defaultProps;
CertificationExcerpt.propTypes = propTypes;
